<template>
    <div class="third">
        <div class="share-button">
                      <span v-b-toggle.collapse-1>
                           <font-awesome-icon icon="share-alt" size="lg" style="color: #f14b70"></font-awesome-icon>
                          share
                        </span>
        </div>
        <div>
            <b-collapse id="collapse-1" class="mt-2">
                <Facebook :url="url" scale="2"></Facebook>
                &nbsp
                <Twitter :url="url" scale="2"></Twitter>
                &nbsp
                <email :url="url" scale="2"></email>
                &nbsp
                <linkedin :url="url" scale="2"></linkedin>
                &nbsp
            </b-collapse>
        </div>
    </div>
</template>

<script>
    import {
        Facebook,
        Twitter,
        Linkedin,
        Email,
    } from "vue-socialmedia-share";

    export default {
        name: "course-share",
        components: {
            Facebook, Twitter, Linkedin, Email
        },
        data() {
            return {
                url: ""
            }
        },
        mounted(){
            this.url = "https://edfore.techgentsia.com"+this.$route.fullPath;
        }
    }
</script>

<style scoped>

</style>